import { FormTextField, FormTextFieldProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props extends Omit<FormTextFieldProps, "name"> {
  name?: string;
  isSupplier?: boolean;
}

export const FormTextFieldOrganisationName = ({
  name = "organisationName",
  label,
  placeholder,
  fullWidth,
  isSupplier,
  ...props
}: Props) => {
  const { t } = useTranslation(["common"]);

  const organisationNameLabelKey = isSupplier
    ? "common:form.text.field.organisation.name.label.supplier"
    : "common:form.text.field.organisation.name.label";

  const organisationNameLabelKeyPlaceholder = isSupplier
    ? "common:form.text.field.organisation.name.placeholder.supplier"
    : "common:form.text.field.organisation.name.placeholder";

  return (
    <FormTextField
      fullWidth={fullWidth ?? true}
      label={label ?? t(organisationNameLabelKey)}
      name={name}
      placeholder={placeholder ?? t(organisationNameLabelKeyPlaceholder)}
      {...props}
    />
  );
};
